import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Home from "./pages/Home";
import Login from "./pages/Login";
import EtapesMarche from './pages/EtapesMarche';
import NotFound from './pages/NotFound';
import Procurement from './pages/procurement';
import Bidder from './pages/bidder';
import Attribution from './pages/procurement/Attribution';
import Order from './pages/procurement/Order';
import Comments from './pages/procurement/Comments';
import Launch from './pages/procurement/Launch';
import Legal from './pages/bidder/Legal';
import Offer from "./pages/bidder/Offer";
import AuthWrapper from './components/AuthWrapper';
import ProcurementSettings from './pages/procurement/settings';
import ProcurementForm from './pages/procurement/Create';
import Contacts from './pages/bidder/Contacts';
import Tracking from './pages/procurement/Tracking';
import Reviews from './pages/bidder/Review';
import Enterprises from './pages/Enterprises';
import Enterprise from './pages/Enterprise';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AuthWrapper><Home /></AuthWrapper>} />
      <Route path="/login" element={<Login />} />
      <Route path="/etapes-marche" element={<EtapesMarche />} />
      <Route path="/enterprises" element={<AuthWrapper><Enterprises /></AuthWrapper>} />
      <Route path="/procurement" element={<AuthWrapper><ProcurementForm /></AuthWrapper>} />
      <Route path="/enterprise/:uuidEnterprise" element={<AuthWrapper><Enterprise /></AuthWrapper>} />
      <Route path="/procurement/:uuidProcurement" element={<AuthWrapper><Procurement /></AuthWrapper>}>
        <Route index element={<Navigate to="launch" replace />} />
        <Route path="launch" element={<Launch />} />
        <Route path="attribution" element={<Attribution />} />
        <Route path="comments" element={<Comments />} />
        <Route path="tracking" element={<Tracking />} />
        <Route path="order" element={<Order />} />
        <Route path="bidder/:uuidEnterprise" element={<AuthWrapper> <Bidder /> </AuthWrapper>}>
          <Route index element={<Navigate to="legal" replace />} />
          <Route path="legal" element={<Legal />} />
          <Route path="offer" element={<Offer />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="reviews" element={<Reviews />} />
        </Route>
        <Route path="settings" element={<ProcurementSettings />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
